<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="section2Data" (change)="section2DataChange()" (submit)="section2DataSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"SECTION_3_TITLE" | translate | titlecase }}</h6>
            </div>

            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                    {{"RESET" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i class="fas fa"></i>
                    {{"NEXT" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>



        </div>
        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        
                        <div class="row" *ngFor ="let question of questionData">
                            <div class="col-md-12 form-group px-md-5 mb-4">
                                <label class="font-bold">
                                    {{
                                        (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                                        }}</label>
                                <input type="text" class="form-control" placeholder="{{
                                    (globals.lang == 'ar')? question.questionDescAr : question.questionDescEn
                                    }}"
                                     *ngIf="question.questionType == 'TEXT'"
                                     formControlName="{{  question.formControlName}}">
                                    <select class="form-control custom-select" 
                                    *ngIf="question.questionType == 'LIST'"
                                    formControlName="{{  question.formControlName}}">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option [ngValue]="(globals.lang == 'ar')? value.valueDescAr : value.valueDescEn" *ngFor ="let value of question.values">{{
                                        (globals.lang == 'ar')? value.valueDescAr : value.valueDescEn
                                        }}</option>

                                </select>
                                <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="section2Data.controls.siblingsCount.touched && section1Data.controls.siblingsCount.invalid && section1Data.dirty">
                                    Please enter a valid Siblings Count
                                </div>  -->
                                <div class="alert alert-danger py-1 mt-1"
                                *ngIf="isTouched(question.formControlName) && isInvalid(question.formControlName) && section2Data.dirty">
                                {{"THIS_QUESTION_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            
                        </div>




                    </div>
                    <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                        <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                            {{"RESET" | translate | titlecase }}</button>
                        <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i class="fas fa"></i>
                            {{"NEXT" | translate | titlecase }}</button>
                        <app-loader [show]="creating"></app-loader>
                    </div>
                    
                </div>
            </div>
        </div>



    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>